/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import PropTypes from 'prop-types';
import { controllable } from '@instructure/ui-prop-types';
import { I18nPropTypes } from '@instructure/ui-i18n';
import { FormPropTypes } from '@instructure/ui-form-field';
import { PositionPropTypes } from '@instructure/ui-position';
const propTypes = {
  renderLabel: PropTypes.oneOfType([PropTypes.node, PropTypes.func]).isRequired,
  defaultToFirstOption: PropTypes.bool,
  value: controllable(I18nPropTypes.iso8601, 'onChange'),
  defaultValue: I18nPropTypes.iso8601,
  id: PropTypes.string,
  format: PropTypes.string,
  step: PropTypes.oneOf([5, 10, 15, 20, 30, 60]),
  interaction: PropTypes.oneOf(['enabled', 'disabled', 'readonly']),
  placeholder: PropTypes.string,
  isRequired: PropTypes.bool,
  isInline: PropTypes.bool,
  width: PropTypes.string,
  optionsMaxWidth: PropTypes.string,
  visibleOptionsCount: PropTypes.number,
  messages: PropTypes.arrayOf(FormPropTypes.message),
  placement: PositionPropTypes.placement,
  constrain: PositionPropTypes.constrain,
  mountNode: PositionPropTypes.mountNode,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  onShowOptions: PropTypes.func,
  onHideOptions: PropTypes.func,
  inputRef: PropTypes.func,
  listRef: PropTypes.func,
  renderEmptyOption: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  renderBeforeInput: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  renderAfterInput: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  locale: PropTypes.string,
  timezone: PropTypes.string,
  allowNonStepInput: PropTypes.bool,
  onInputChange: PropTypes.func,
  allowClearingSelection: PropTypes.bool
};
const allowedProps = ['renderLabel', 'defaultToFirstOption', 'value', 'defaultValue', 'id', 'format', 'step', 'interaction', 'placeholder', 'isRequired', 'isInline', 'width', 'optionsMaxWidth', 'mountNode', 'visibleOptionsCount', 'messages', 'placement', 'constrain', 'onChange', 'onFocus', 'onBlur', 'onShowOptions', 'onHideOptions', 'inputRef', 'listRef', 'renderEmptyOption', 'renderBeforeInput', 'renderAfterInput', 'locale', 'timezone', 'allowNonStepInput', 'onInputChange', 'allowClearingSelection'];
export { propTypes, allowedProps };